"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterceptorsController = void 0;
var base_request_1 = require("../../requests/base-request");
var InterceptorsController = /** @class */ (function () {
    function InterceptorsController() {
    }
    InterceptorsController.prototype.addRequestInterceptor = function (interceptor) {
        base_request_1.BaseRequest.requestInterceptors.push(interceptor);
    };
    InterceptorsController.prototype.addResponseInterceptor = function (interceptor) {
        base_request_1.BaseRequest.responseInterceptors.push(interceptor);
    };
    return InterceptorsController;
}());
exports.InterceptorsController = InterceptorsController;
